import "./App.css";
import AddCart from "./Compunents/AddCart";
import Details from "./Compunents/Details";
import Home from "./Compunents/Home";
import Navbar from "./Compunents/Navbar";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Footer from "./Compunents/Footer";
import { BrowserRouter, Routes, Route } from "react-router-dom";

function App() {
  return (
    <>
      <BrowserRouter>
        <ToastContainer />
        <Navbar />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/add" element={<AddCart />} />
          <Route path="/:id" element={<Details />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </>
  );
}

export default App;
